/**
 * Asynchronously loads the component for CampusStudents
 */

import { lazyLoad } from "utils/loadable";

export const CampusStudents = lazyLoad(
  () => import("./index"),
  (module) => module.CampusStudents
);
